import React, { useState, useEffect, useMemo, useContext } from 'react'
import moment from 'moment'
import { Table } from 'antd';
import { toast } from 'react-toastify';
import useFetchUserRoles from '../../../hook'
import FeeTableHeader from './FeeTableHeader';
import StudentContext from '../../../Helper/Students';
import courseContext from '../../../Helper/Courses';
import { getFeeColumn } from '../../../utils/feeColumn';
import { searchInArray } from '../../../utils/search'
import { COURSE_TRANSFER, MODULE_TRANSFER } from '../../../Constant';
import { isAccess, isWriteAccess } from '../../../utils/adminRoles'
import { getCourseNameFromCourseId } from '../../../utils/course';
import { showAlert } from '../../../utils/alert';
import { addAdminActivity, changeStudentCourse } from '../../../firebase/utils';
import AdminContext from '../../../Helper/admin';
import { numberToOrdinalText } from '../../../utils';

const FeesTable = () => {
  const { students, loading, setLoading, setStudents, fetchStudents } = useContext(StudentContext)
  const { user, location } = useContext(AdminContext)
  const { activeCourse, courses } = useContext(courseContext)
  const [courseStudents, setCourseStudents] = useState([])
  const [feeAmount, setFeeAmount] = useState(false)
  const [courseLoading, setCourseLoading] = useState({
    data: null,
    loading: false
  })
  const [moduleLoading, setModuleLoading] = useState({
    data: null,
    loading: false
  })
  const [feeStatus, setFeeStatus] = useState({});
  const [search, setSearch] = useState("")
  const [module, setModule] = useState(0)
  const hasAccessToCourseTranfer = useFetchUserRoles('courseTransfer', isAccess)

  const filteredStudent = useMemo(() => {
    const keys = ['studentId', 'email', 'fullName']
    const studentFilteredData = searchInArray(courseStudents, keys, search)
    return studentFilteredData
  }, [search, courseStudents])

  const modifiedStudentsData = (data) => {
    const index = students.findIndex((student) => student.email === data.email)
    setStudents(previousStudents => {
      const newStudent = [...previousStudents];
      newStudent[index] = data;
      return newStudent;
    });
  }

  const transferStudentCourse = async (courseId, data) => {
    if (hasAccessToCourseTranfer) {
      if (data.courses[data.courseIndex].courseId == courseId) return
      const warningText = `Are you sure you want to change the course to ${getCourseNameFromCourseId(courses, courseId)} for this user? <br/><br/> Email: ${data.email}`
      const isConfirm = await showAlert(warningText)
      if (isConfirm) {
        const newCourseName = courses.find((cour) => cour.id === courseId)
        const activityOptions = {
          adminId: user.email,
          activityOnUser: data.email,
          fromCourse: {
            courseName: `${activeCourse.name} ${activeCourse.type}`,
          },
          toCourse: {
            courseName: `${newCourseName.name} ${newCourseName.type}`,
          },
          type: module >= 1 ? MODULE_TRANSFER : COURSE_TRANSFER,
          createdAt: new Date(),
          activity: `${user.email} ${module == 1
            ? `transferred ${data.email}'s  module 2`
            : `transferred ${data.email}'s course`
            } from ${activeCourse.name} ${activeCourse.type} to ${newCourseName.name
            } ${newCourseName.type}`,
        };
        setCourseLoading({ data, loading: true });
        try {
          if (module == 1) {
            activityOptions.fromCourse.module = 2;
            activityOptions.toCourse.module = 1;
            const newFee = data.courses[data.courseIndex].feeScreenshots[1];
            data.courses[data.courseIndex].feeScreenshots.splice(1, 1);
            const newCourse = {
              courseId: courseId,
              feeScreenshots: newFee ? [newFee] : [],
              enrolledAt: new Date(),
              current: true,
            };
            data.courses.push(newCourse);
          } else {
            data.courses[data.courseIndex].courseId = courseId;
          }
          await changeStudentCourse(data.email, data.courses);
          await addAdminActivity(activityOptions, location);
          filterStudent(data);
          toast.success("Course updated successfully!");
        } catch (error) {
          toast.error(error);
        } finally {
          setCourseLoading({ data: null, loading: false });
        }
      }
    } else {
      toast.error(
        "You don't have access, please ask Super Admin to provide you access!"
      );
    }
  }

  const transferFirstModule = async (data) => {
    if (hasAccessToCourseTranfer) {
      const hasBothModulesPaid = data.courses[data.courseIndex].feeScreenshots[0]?.status === 'verified' && data.courses[data.courseIndex].feeScreenshots[1]?.status === 'verified'

      if(hasBothModulesPaid) return;
      try {
        const warningText = `Are you sure you want to transfer "${data?.fullName}'s" current module to ${activeCourse.name}'s ${numberToOrdinalText(module ? 1 : 2)} module? <br/><br/> Email: ${data.email}`;
        
        const isConfirm = await showAlert(warningText)
        if (isConfirm) {
          setModuleLoading({ loading: true, data });

          if (data.courses[data.courseIndex].feeScreenshots[0]?.skipModule && module > 0) {
            data.courses[data.courseIndex].feeScreenshots.shift()
          } else {
            data.courses[data.courseIndex].feeScreenshots.unshift({
              skipModule: true
            })
          }

          const activityOptions = {
            adminId: user.email,
            activityOnUser: data.email,
            fromCourse: {
              courseName: `${activeCourse.name} ${activeCourse.type} module ${module + 1}`,
            },
            toCourse: {
              courseName: `${activeCourse.name} ${activeCourse.type} module ${module ? '1' : '2'}`,
            },
            type: MODULE_TRANSFER,
            createdAt: new Date(),
            activity: `${user.email} 
            transferred ${data?.email}'s  module ${module + 1} to ${activeCourse.name
              } ${activeCourse.type}  module ${module ? '1' : '2'}`
          };
          await changeStudentCourse(data.email, data.courses);
          await addAdminActivity(activityOptions, location);
          filterStudent(data);
          toast.success("Course updated successfully!");
        }

      } catch (error) {
        console.log(error)
      } finally {
        setModuleLoading({ loading: false, data: null })
      }
    } else {
      toast.error(
        "You don't have access, please ask Super Admin to provide you access!"
      );
    }
  }

  const filterStudent = (data) => {
    modifiedStudentsData(data)
    const filteredArray = courseStudents.filter((student) => {
      return student.email !== data.email;
    });
    setCourseStudents(filteredArray);
  };

  const setTotal = () => {
    const feeStatusTemp = {
      verified: 0,
      rejected: 0,
      pending: 0,
      unpaid: 0,
      totalWithScreenshot: 0,
      total: 0,
      refundAmount: 0,
      totalAmount: 0,
    };
    // console.log(courseStudents)
    feeStatusTemp.total = courseStudents.length;

    courseStudents.map((student) => {
      const course = student.courses[student.courseIndex];
      if (!course) return;
      const fees = course.feeScreenshots[module];
      if (!fees) return feeStatusTemp.unpaid++;
      switch (fees.status) {
        case "notVerified": {
          feeStatusTemp.rejected++;
          feeStatusTemp.totalWithScreenshot++;
          break;
        }
        case "verified": {
          feeStatusTemp.verified++;
          feeStatusTemp.totalWithScreenshot++;
          feeStatusTemp.totalAmount += fees.feeAmount ? +fees.feeAmount.toFixed(1) : 0;
          break;
        }
        case "pending": {
          feeStatusTemp.pending++;
          feeStatusTemp.totalWithScreenshot++;
          break;
        }
        case "refunded": {
          const refunedAmount = fees.feeAmount - +fees.refundAmount
          feeStatusTemp.totalAmount += refunedAmount ? refunedAmount : 0
          feeStatusTemp.refundAmount += fees.refundAmount ? +fees.refundAmount : 0
          break;
        }
      }
    });

    setFeeStatus(feeStatusTemp);
  };

  const getStudents = async () => {
    const records = [];
    const refundStudents = []
    if (!students.length) return
    students?.forEach((student) => {
      const selectedCourseStudents = student?.courses?.find(
        (cour) => cour.courseId === activeCourse?.id
      );
      const courIndex = student?.courses?.findIndex(
        (cour) => cour.courseId === activeCourse?.id
      );
      const isRefundedFee = selectedCourseStudents?.feeScreenshots?.find((courseFee) => courseFee.status === 'refunded')
      if (isRefundedFee) {
        let studentData = { ...student, docId: student.id, courseIndex: courIndex, isRefund: true };
        refundStudents.push(studentData)
        return
      }
      if (selectedCourseStudents) {
        let studentData = { ...student, docId: student.id, courseIndex: courIndex };
        records.push(studentData);
      }
    });
    const sortedData = records
      .map((obj) => {
        const courses = obj.courses.map((course) => {
          if (course.feeScreenshots.length > 0) {
            let fees = course.feeScreenshots
              .slice()
              .sort((a, b) => {
                if (!a.date || !b.date || !b.skipModule) return
                return moment(a.date.toDate()) - moment(b.date.toDate());
              });
            return { ...course, feeScreenshots: fees };
          } else {
            return course;
          }
        });
        return { ...obj, courses };
      })
      ?.sort((a, b) => {
        const aFee = findLastFee(a);
        const bFee = findLastFee(b);
        if (aFee && bFee) {
          return moment(bFee.date) - moment(aFee.date);
        } else if (aFee) {
          return -1;
        } else if (bFee) {
          return 1;
        } else {
          return 0;
        }
      });
    function findLastFee(record) {
      let lastFee = null;
      for (const course of record.courses) {
        if (course.feeScreenshots.length > 0) {
          const fee = course.feeScreenshots[course.feeScreenshots.length - 1];
          const feeDate = (fee.date && typeof fee.date.toDate === 'function') ? fee.date.toDate() : fee.date;
          if (feeDate && (!lastFee || moment(feeDate).isAfter(lastFee.date))) {
            lastFee = { ...fee, date: feeDate }; // store JavaScript Date in lastFee object
          }
        }
      }
      return lastFee;
    }
    const modifiedData = [...sortedData].concat(refundStudents)
    setCourseStudents(modifiedData)
    setLoading(false)
  };

  const columnData = getFeeColumn(
    module,
    transferStudentCourse,
    transferFirstModule,
    courseLoading,
    setCourseStudents,
    courseStudents,
    setTotal,
    feeAmount,
    setFeeAmount,
    activeCourse,
    moduleLoading
  )

  useEffect(() => {
    setTotal()
  }, [module, courseStudents])

  useEffect(() => {
    fetchStudents(activeCourse)
  }, [])  

  useEffect(() => {
    getStudents()
  }, [students, activeCourse])

  return (
    <>
      <FeeTableHeader
        module={module}
        setModule={setModule}
        feeStatus={feeStatus}
        courseStudents={courseStudents}
        search={search}
        setSearch={setSearch}
        feeAmount={feeAmount}
        setFeeAmount={setFeeAmount}
      />
      <div className='ant-design-table'>
        <Table
          loading={loading}
          rowClassName={(record) => record.banned ? 'banned-student' : ''}
          columns={columnData}
          dataSource={filteredStudent}
          bordered={true}
          pagination={false}
          scroll={{ x: "auto" }}
        />
      </div>
    </>
  )
}

export default FeesTable